/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateBotStrategyByIdOptions,
  UpdateBotStrategyByIdStatus200,
  UpdateBotStrategyByIdStatus400,
  UpdateBotStrategyByIdStatus404,
  UpdateBotStrategyByIdStatus500,
} from '../types/UpdateBotStrategyById'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateBotStrategyById } from '../clients/updateBotStrategyById'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateBotStrategyByIdMutationKey = () =>
  [{ url: '/v1/bot/strategies/:strategy_id' }] as const

export function updateBotStrategyByIdMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateBotStrategyByIdMutationKey()
  return mutationOptions<
    UpdateBotStrategyByIdStatus200,
    ResponseErrorConfig<
      | UpdateBotStrategyByIdStatus400
      | UpdateBotStrategyByIdStatus404
      | UpdateBotStrategyByIdStatus500
    >,
    UpdateBotStrategyByIdOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateBotStrategyById({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Update an existing bot strategy by its unique ID. Only admin users can perform this operation. The request body must contain the updated strategy details.
 * @summary Update Bot Strategy by ID
 * {@link /v1/bot/strategies/:strategy_id}
 */
export function useUpdateBotStrategyById<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateBotStrategyByIdStatus200,
      ResponseErrorConfig<
        | UpdateBotStrategyByIdStatus400
        | UpdateBotStrategyByIdStatus404
        | UpdateBotStrategyByIdStatus500
      >,
      UpdateBotStrategyByIdOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateBotStrategyByIdMutationKey()

  const baseOptions = updateBotStrategyByIdMutationOptions(config) as UseMutationOptions<
    UpdateBotStrategyByIdStatus200,
    ResponseErrorConfig<
      | UpdateBotStrategyByIdStatus400
      | UpdateBotStrategyByIdStatus404
      | UpdateBotStrategyByIdStatus500
    >,
    UpdateBotStrategyByIdOptions,
    TContext
  >

  return useMutation<
    UpdateBotStrategyByIdStatus200,
    ResponseErrorConfig<
      | UpdateBotStrategyByIdStatus400
      | UpdateBotStrategyByIdStatus404
      | UpdateBotStrategyByIdStatus500
    >,
    UpdateBotStrategyByIdOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateBotStrategyByIdStatus200,
    ResponseErrorConfig<
      | UpdateBotStrategyByIdStatus400
      | UpdateBotStrategyByIdStatus404
      | UpdateBotStrategyByIdStatus500
    >,
    UpdateBotStrategyByIdOptions,
    TContext
  >
}
